{
  "PROFILE_SETTINGS": {
    "LINK": "Configurações do perfil",
    "TITLE": "Configurações do perfil",
    "BTN_TEXT": "Atualizar o perfil",
    "DELETE_AVATAR": "Apagar Avatar",
    "AVATAR_DELETE_SUCCESS": "Avatar foi apagado com sucesso",
    "AVATAR_DELETE_FAILED": "Ocorreu um erro a apagar o avatar. Por favor, tente novamente",
    "UPDATE_SUCCESS": "O seu perfil foi atualizado com sucesso",
    "PASSWORD_UPDATE_SUCCESS": "Sua senha foi alterada com sucesso",
    "AFTER_EMAIL_CHANGED": "Seu perfil foi atualizado com sucesso, faça o login novamente pois suas credenciais foram alteradas",
    "FORM": {
      "PICTURE": "Imagem de perfil",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Imagem da assinatura de e-mail",
        "HINT": "Utilizada nas assinaturas de e-mail. {'{{'}email_signature_picture{'}}'} é substituído pelo URL desta imagem (não uma etiqueta de imagem) — utilize-o como origem da imagem (o atributo src de uma etiqueta img) na sua assinatura ou na assinatura da caixa de entrada. Se não estiver definida, nada é inserido.",
        "DELETE_SUCCESS": "A imagem da assinatura de e-mail foi eliminada com sucesso",
        "DELETE_FAILED": "Ocorreu um erro ao eliminar a imagem da assinatura de e-mail, por favor tente novamente"
      },
      "AVATAR": "Imagem do perfil",
      "ERROR": "Por favor, corrigir erros de formulário",
      "REMOVE_IMAGE": "Excluir",
      "UPLOAD_IMAGE": "Upload de imagem",
      "UPDATE_IMAGE": "Atualizar imagem",
      "PROFILE_SECTION": {
        "TITLE": "Perfil",
        "NOTE": "Seu endereço de e-mail é sua identidade e é usado para entrar."
      },
      "SEND_MESSAGE": {
        "TITLE": "Tecla de atalho para enviar mensagens",
        "NOTE": "É possível selecionar uma tecla de atalho (Enter ou Cmd/Ctrl+Enter) com base na sua preferência de escrita.",
        "UPDATE_SUCCESS": "As suas configurações foram atualizadas com sucesso",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Enviar mensagens pressionando a tecla Enter em vez de clicar no botão enviar."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Enviar mensagens com as teclas Cmd/Ctrl + Enter em vez de clicar no botão enviar."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Personalize o aspeto e o comportamento do seu dashboard.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Padrão",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Idioma do painel",
          "NOTE": "Substitua o idioma da conta apenas para o seu painel. Deixe vazio para utilizar a predefinição da conta.",
          "USE_ACCOUNT_DEFAULT": "Utilizar a predefinição da conta",
          "API_SUCCESS": "O idioma do seu painel foi atualizado com sucesso"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Idioma da mensagem",
          "NOTE": "Escolha se pretende ver as mensagens originais ou as suas traduções",
          "ORIGINAL": "Original",
          "TRANSLATED": "Traduzida"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Comportamento ao colar",
          "NOTE": "Escolha como o conteúdo colado deve ser processado ao escrever mensagens",
          "UPDATE_SUCCESS": "As suas configurações de colagem foram atualizadas com sucesso",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Preservar toda a formatação",
              "DESCRIPTION": "Mantém toda a formatação, incluindo tabelas, estilos e outros elementos HTML, ao colar conteúdo."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Apenas texto com ligações",
              "DESCRIPTION": "Converte para texto simples, mas preserva as ligações clicáveis ao colar conteúdo."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Apenas texto simples",
              "DESCRIPTION": "Remove toda a formatação e converte para texto simples ao colar conteúdo."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Altura da caixa de resposta",
          "NOTE": "Defina a altura mínima da caixa de resposta como uma porcentagem da altura da tela. Aplica-se apenas a conversas por e-mail.",
          "UPDATE_SUCCESS": "As suas configurações de altura da caixa de resposta foram atualizadas com sucesso",
          "PERCENT_LABEL": "Altura (% da altura da tela)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Padrão",
              "DESCRIPTION": "A caixa de resposta começa pequena e cresce à medida que você digita."
            },
            "CUSTOM": {
              "HEADING": "Personalizado",
              "DESCRIPTION": "A caixa de resposta ocupa sempre pelo menos a porcentagem escolhida da altura da tela."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Navegar automaticamente para a conversa seguinte",
        "NOTE": "Muda automaticamente para a próxima conversa aberta depois de resolver a atual",
        "UPDATE_SUCCESS": "Configuração de navegação automática atualizada com sucesso"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Assinatura de mensagem pessoal",
        "DESCRIPTION": "Crie uma assinatura de mensagem exclusiva, apresentada no final de todos os e-mails que enviar. Também pode incluir uma imagem incorporada.",
        "NOTE": "Crie uma assinatura de mensagem única para aparecer no final de todas as mensagens que enviar de qualquer caixa de entrada. Pode incluir uma imagem embutida, que será suportada nos canais de live-chat, e-mail e caixas de entrada API.",
        "BTN_TEXT": "Salvar assinatura da mensagem",
        "API_ERROR": "Não foi possível salvar a assinatura! Tente novamente",
        "API_SUCCESS": "Assinatura salva com sucesso",
        "IMAGE_UPLOAD_ERROR": "Não foi possível carregar a imagem! Tente novamente",
        "IMAGE_UPLOAD_SUCCESS": "Imagem adicionada. Clique em salvar para salvar a assinatura",
        "IMAGE_UPLOAD_SIZE_ERROR": "O tamanho da imagem deve ser inferior a {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Assinatura da mensagem",
        "ERROR": "Assinatura da mensagem não pode estar vazia",
        "PLACEHOLDER": "Escreva aqui a sua assinatura de mensagem pessoal."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Palavra-passe",
        "NOTE": "Atualizar sua senha irá redefinir seus logins em vários dispositivos.",
        "BTN_TEXT": "Alterar password"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Token de acesso",
        "NOTE": "Este token pode ser usado se você estiver construindo uma integração baseada em API",
        "COPY": "Copiar",
        "REGENERATE": "Regenerar",
        "REGENERATE_SUCCESS": "Token de acesso regenerado com sucesso. Atualize as integrações que utilizem o token antigo.",
        "REGENERATE_CONFIRM_TITLE": "Regenerar o token de acesso?",
        "REGENERATE_CONFIRM_MESSAGE": "Isto irá invalidar o token atual. As integrações que utilizem o token antigo deixarão de funcionar."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Extensão do Chrome",
        "NOTE": "Instale a nossa extensão do Chrome para receber notificações detalhadas sobre chamadas telefónicas recebidas.",
        "INSTALL_BUTTON": "Instalar extensão",
        "ALREADY_INSTALLED": "Extensão instalada"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "Nenhuma",
          "MINE": "Atribuída",
          "ALL": "Todas",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Eventos de alerta para conversas",
          "NONE": "Nenhuma",
          "ASSIGNED": "Conversas atribuídas",
          "ALL_CONVERSATIONS": "Todas as conversas"
        },
        "DEFAULT_TONE": {
          "TITLE": "Tom do alerta:"
        },
        "CONDITIONS": {
          "TITLE": "Condições de alerta:",
          "CONDITION_ONE": "Enviar alertas de áudio apenas quando a janela do navegador não estiver ativa",
          "CONDITION_TWO": "Enviar alertas a cada 30 segundos até que todas as conversas atribuídas sejam lidas"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Ler mais"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Notificações por e-mail",
        "NOTE": "Atualize suas preferências de notificação por e-mail aqui",
        "CONVERSATION_ASSIGNMENT": "Enviar notificações por email quando uma conversa é atribuída a mim",
        "CONVERSATION_CREATION": "Enviar notificações por email quando uma nova conversa é criada",
        "CONVERSATION_MENTION": "Enviar notificações por email quando for mencionado numa conversa",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Enviar mensagem de email quando criada uma mensagem ou atribuída uma conversa",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Enviar notificações por email quando uma nova mensagem é criada numa conversa em que está a participar",
        "SLA_MISSED_FIRST_RESPONSE": "Enviar notificações por e-mail quando uma conversa perder a primeira resposta SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Enviar notificações por email quando uma conversa falhar a SLA de primeira resposta",
        "SLA_MISSED_RESOLUTION": "Enviar notificações por email quando uma conversa falhar a SLA de resolução"
      },
      "NOTIFICATIONS": {
        "TITLE": "Preferências de notificação",
        "TYPE_TITLE": "Tipo de notificação",
        "EMAIL": "e-mail",
        "PUSH": "Notificações Push",
        "TYPES": {
          "CONVERSATION_CREATED": "Nova conversa criada",
          "CONVERSATION_ASSIGNED": "Foi-lhe atribuída uma conversa",
          "CONVERSATION_MENTION": "Foi mencionado numa conversa",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Foi criada uma nova mensagem numa conversa que lhe está atribuída",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Foi criada uma nova mensagem numa conversa em que está a participar",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "É criada uma nova mensagem numa conversa sem agente disponível",
          "SLA_MISSED_FIRST_RESPONSE": "Uma conversa perdeu a primeira resposta SLA",
          "SLA_MISSED_NEXT_RESPONSE": "Uma conversa perdeu a a próxima resposta SLA",
          "SLA_MISSED_RESOLUTION": "Uma conversa falhou a SLA de resolução"
        },
        "BROWSER_PERMISSION": "Ative as notificações Push do seu navegador para que as possa receber",
        "ALLOW_NOTIFICATION_DURING_CALL": "Permitir notificações push enquanto estiver numa chamada",
        "TEST_PUSH": "Testar",
        "TESTING": "A testar...",
        "TEST_PUSH_DESCRIPTION": "Envie notificações de teste para verificar a sua configuração",
        "TEST_NOTIFICATION_ERROR": "Não foi possível enviar a notificação de teste. Tente novamente.",
        "TEST_LOCAL_TITLE": "Notificação de teste (local)",
        "TEST_LOCAL_BODY": "Esta é uma notificação local do navegador. Se está a ver isto, as notificações do navegador estão a funcionar!"
      },
      "API": {
        "UPDATE_SUCCESS": "As suas preferências de notificação foram atualizadas com sucesso",
        "UPDATE_ERROR": "Ocorreu um erro ao atualizar as suas preferências, por favor, tente de novo"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Notificações Push",
        "NOTE": "Atualize aqui as suas preferências de notificação Push",
        "CONVERSATION_ASSIGNMENT": "Enviar uma notificação Push quando uma conversa me for atribuída",
        "CONVERSATION_CREATION": "Enviar uma notificação Push quando uma conversa é criada",
        "CONVERSATION_MENTION": "Enviar uma notificação Push quando for mencionado numa conversa",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Enviar uma notificação Push quando uma mensagem é criada numa conversa atribuída",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Enviar notificações push quando uma nova mensagem é criada numa conversa em que está a participar",
        "HAS_ENABLED_PUSH": "Ativou notificações Push neste navegador.",
        "REQUEST_PUSH": "Ativar notificações Push",
        "SLA_MISSED_FIRST_RESPONSE": "Enviar uma notificação Push quando uma conversa falhar a SLA de primeira resposta",
        "SLA_MISSED_NEXT_RESPONSE": "Enviar uma notificação Push quando uma conversa falhar a SLA de resposta seguinte",
        "SLA_MISSED_RESOLUTION": "Enviar uma notificação Push quando uma conversa falhar a SLA de resolução"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Imagem do perfil"
      },
      "NAME": {
        "LABEL": "O seu nome completo",
        "ERROR": "Por favor, digite um nome completo válido",
        "PLACEHOLDER": "Por favor, digite o seu nome completo"
      },
      "DISPLAY_NAME": {
        "LABEL": "Mostrar nome",
        "ERROR": "Por favor, digite uma alcunha válida",
        "PLACEHOLDER": "Por favor, escolha uma alcunha que será mostrada nas conversas"
      },
      "POSITION": {
        "LABEL": "Cargo",
        "ERROR": "Introduza um cargo válido",
        "PLACEHOLDER": "Introduza o seu cargo"
      },
      "CUSTOM_LINE": {
        "LABEL": "Linha personalizada",
        "ERROR": "Introduza uma linha personalizada válida",
        "PLACEHOLDER": "Introduza a sua linha personalizada"
      },
      "AVAILABILITY": {
        "LABEL": "Disponibilidade",
        "STATUS": {
          "ONLINE": "Disponível",
          "BUSY": "Ocupado",
          "OFFLINE": "Ausente"
        },
        "SET_AVAILABILITY_SUCCESS": "Disponibilidade foi definida com sucesso",
        "SET_AVAILABILITY_ERROR": "Não foi possível definir a disponibilidade, por favor tente novamente"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Formato de pré-visualização de e-mail na lista de conversas",
        "NOTE": "Escolha o que é exibido na lista de conversas para conversas de caixas de entrada de e-mail",
        "SUBJECT": "Assunto",
        "SUBJECT_WITH_NOTE": "Assunto e a última mensagem, caso seja uma nota interna",
        "UPDATE_SUCCESS": "A configuração de pré-visualização de e-mail foi atualizada com sucesso"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Desativar atalhos de teclado",
        "NOTE": "Desliga todos os atalhos de teclado em toda a aplicação",
        "UPDATE_SUCCESS": "Configuração de atalhos de teclado atualizada com sucesso"
      },
      "FOLDER_ORDER": {
        "TITLE": "Ordem das pastas",
        "NOTE": "Personalize a ordem pela qual as pastas (vistas personalizadas) aparecem na barra lateral. Arraste e solte para reordenar.",
        "NO_FOLDERS": "Não foram encontradas pastas personalizadas. Crie pastas para organizar as suas conversas."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Configuração da barra lateral",
        "NOTE": "Personalize as secções que aparecem na barra lateral das conversas.",
        "SAVE_BUTTON": "Guardar configuração",
        "UPDATE_SUCCESS": "Configuração da barra lateral atualizada com sucesso",
        "UPDATE_ERROR": "Ocorreu um erro ao atualizar a configuração da barra lateral, tente novamente",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Todas as conversas",
          "ALL_CONVERSATIONS_DESC": "Mostra o item de menu Todas as conversas na barra lateral",
          "INBOX": "Caixa de entrada",
          "INBOX_DESC": "Mostra a caixa de entrada principal com as notificações não lidas",
          "CONVERSATION_GROUPS": "Menções e Por responder",
          "CONVERSATION_GROUPS_DESC": "Mostra os grupos de conversas Menções e Por responder",
          "FOLDERS": "Pastas",
          "FOLDERS_DESC": "Mostra vistas personalizadas (pastas) para organizar conversas",
          "TEAMS": "Equipas",
          "TEAMS_DESC": "Mostra conversas filtradas por atribuições de equipa",
          "CHANNELS": "Caixas de entrada",
          "CHANNELS_DESC": "Mostra conversas filtradas por caixa de entrada",
          "LABELS": "Etiquetas",
          "LABELS_DESC": "Mostra conversas filtradas por etiquetas"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Configurações de telefone",
        "NOTE": "Introduza as credenciais de acesso ao seu sistema PBX.",
        "USERNAME": "Nome de utilizador",
        "PASSWORD": "Palavra-passe",
        "SUBMIT": "Guardar",
        "USERNAME_INVALID": "O nome de utilizador só pode conter letras, dígitos e . _ - + — sem espaços e sem endereço de e-mail.",
        "API": {
          "USERNAME_INVALID": "O nome de utilizador não é um nome de utilizador SIP válido. Utilize apenas letras, dígitos e . _ - + — sem espaços e sem endereço de e-mail.",
          "USERNAME_TAKEN": "Este nome de utilizador já está a ser utilizado por outro agente nesta conta."
        }
      },
      "EMAIL": {
        "LABEL": "Seu endereço de e-mail",
        "ERROR": "Por favor, insira um endereço de e-mail válido",
        "PLACEHOLDER": "Por favor, insira seu endereço de e-mail, que será exibido em conversas"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Password atual",
        "ERROR": "Por favor, digite a password atual",
        "PLACEHOLDER": "Por favor, digite a password atual"
      },
      "PASSWORD": {
        "LABEL": "Nova senha",
        "ERROR": "Por favor, digite uma senha de comprimento 6 ou mais",
        "PLACEHOLDER": "Por favor, digite uma nova senha"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Confirme a nova senha",
        "ERROR": "Confirme a senha deve corresponder à senha",
        "PLACEHOLDER": "Por favor, digite novamente a sua senha nova"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Trocar",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Reportar um erro",
    "SELECTOR_SUBTITLE": "Escolha uma conta da lista a seguir",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Reportar um erro",
    "DESCRIPTION_LABEL": "Descrição do problema",
    "DESCRIPTION_PLACEHOLDER": "Descreva o problema que encontrou...",
    "SUBMIT": "Enviar relatório",
    "SUBMITTING": "A enviar...",
    "CANCEL": "Cancelar",
    "SUCCESS": "Relatório de erro enviado com sucesso. Obrigado!",
    "VALIDATION_ERROR": "Descreva o problema antes de enviar"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "dias de teste restantes.",
    "TRAIL_BUTTON": "Comprar agora",
    "DELETED_USER": "Utilizador Excluído",
    "EMAIL_VERIFICATION_PENDING": "Parece que o seu endereço de e-mail ainda não foi verificado. Por favor, confira a sua caixa de entrada e siga as instruções para concluir a verificação.",
    "RESEND_VERIFICATION_MAIL": "Reenviar e-mail de verificação",
    "EMAIL_VERIFICATION_SENT": "O e-mail de verificação foi enviado. Por favor, confira a sua caixa de entrada.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Conta Suspensa",
      "MESSAGE": "A sua conta está suspensa. Entre em contato com a equipa de suporte para obter mais informações."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Copiar",
      "CODEPEN": "Abrir em CodePen",
      "COPY_SUCCESSFUL": "Código copiado com sucesso para área de transferência"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Mostrar mais",
      "SHOW_LESS": "Mostrar menos"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "BAIXAR",
      "UPLOADING": "A carregar...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Esta história já não está disponível.",
      "RECORDING_UNAVAILABLE": "Esta gravação já não está disponível.",
      "DELETE_RECORDING": {
        "BUTTON": "Eliminar gravação da chamada",
        "TITLE": "Eliminar a gravação da chamada?",
        "DESCRIPTION": "Todas as gravações desta chamada serão eliminadas permanentemente do sistema telefónico e não poderão ser restauradas. A transcrição e o resumo da chamada são mantidos.",
        "CONFIRM": "Eliminar",
        "SUCCESS": "Gravação da chamada eliminada",
        "ERROR": "Não foi possível eliminar a gravação da chamada. Tente novamente."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Veja no mapa"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "submeter"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "A verificar...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Adicionar caixa de entrada"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Atualmente visualizando:",
    "SWITCH": "Alternar",
    "INBOX_VIEW": "Visualização da Caixa de entrada",
    "CONVERSATIONS": "Conversas",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "Todas as conversas",
    "MENTIONED_CONVERSATIONS": "Menções",
    "PARTICIPATING_CONVERSATIONS": "Participando",
    "UNATTENDED_CONVERSATIONS": "Por responder",
    "REPORTS": "relatórios",
    "SETTINGS": "Configurações",
    "CONTACTS": "Contactos",
    "DATA_ASSISTANT": "Assistente de Dados",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Principal",
    "AGENTS": "Agentes",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Logs de auditoria",
    "WHATSAPP_TEMPLATES": "Templates do WhatsApp",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Caixas de Entrada",
    "NOTIFICATIONS": "Notificaçoes",
    "CANNED_RESPONSES": "Respostas Prontas",
    "INTEGRATIONS": "Integrações",
    "PROFILE_SETTINGS": "Configurações do perfil",
    "ACCOUNT_SETTINGS": "Configurações da conta",
    "APPLICATIONS": "Aplicações",
    "LABELS": "Etiquetas",
    "CUSTOM_ATTRIBUTES": "Atributos personalizados",
    "AUTOMATION": "Automatização",
    "MACROS": "Macros",
    "TEAMS": "Equipas",
    "BILLING": "Cobrança",
    "CUSTOM_VIEWS_FOLDER": "Pastas",
    "CUSTOM_VIEWS_SEGMENTS": "Segmentos",
    "ALL_CONTACTS": "Todos os contatos",
    "TAGGED_WITH": "Etiquetada com",
    "NEW_LABEL": "Nova etiqueta",
    "NEW_TEAM": "Nova equipa",
    "NEW_INBOX": "Nova caixa de entrada",
    "REPORTS_CONVERSATION": "Conversas",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Campanhas",
    "ONGOING": "Em curso",
    "ONE_OFF": "Pontual",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agentes",
    "REPORTS_LABEL": "Etiquetas",
    "REPORTS_INBOX": "Caixa de Entrada",
    "REPORTS_TEAM": "Equipa",
    "REPORTS_PHONE": "Telefone",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Visão geral",
    "WALLBOARD_QUEUES": "Filas",
    "DATA_ASSISTANT_CHAT": "Chat",
    "DATA_ASSISTANT_REPORTS": "Relatórios",
    "NO_WAITING_CALLERS": "sem chamadores em espera",
    "WAITING_CALLERS": "{count} chamadores em espera",
    "SET_AVAILABILITY_TITLE": "Defina-se como",
    "SET_YOUR_AVAILABILITY": "Definir disponibilidade",
    "AVAILABILITY_IMPERSONATING": "Bloqueado enquanto tiver sessão iniciada como este utilizador",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Funções personalizadas",
    "NEW_CONVERSATION": "Nova conversa",
    "DRAFT": "Rascunho",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Visão geral",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Centro de Suporte",
      "ARTICLES": "Articles",
      "CATEGORIES": "Categorias",
      "LOCALES": "Locais",
      "SETTINGS": "Configurações",
      "DICTIONARY": "Dicionário"
    },
    "CHANNELS": "Channels",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Marcar offline automaticamente",
      "INFO_TEXT": "Deixar o sistema alterar automaticamente o seu estado para offline quando não estiver a usar a app ou o painel.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Ler documentos"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Domínios e contactos bloqueados",
    "DESCRIPTION": "Lista de domínios de e-mail bloqueados para esta conta.",
    "NO_BLOCKED_DOMAINS": "Não foram encontrados domínios bloqueados.",
    "BLOCKED_CONTACTS_BTN": "Contactos bloqueados"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Cobrança",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Plano atual",
      "PLAN_NOTE": "Atualmente tem o **{plan}* subscrito com **{quantity}** licenças",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Administrar o seu serviço",
      "DESCRIPTION": "Visualize as suas faturas anteriores, edite os seus dados de pagamento, ou cancele o seu serviço.",
      "BUTTON_TXT": "Ir para a área de faturação"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Precisa de ajuda?",
      "DESCRIPTION": "Está com dificuldade em efetuar o seu pagamento? Estamos aqui para ajudar.",
      "BUTTON_TXT": "Fale connosco"
    },
    "NO_BILLING_USER": "Os seus dados de pagamento estão a ser configurados. Atualize a página e tente novamente."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Não conseguimos encontrar nenhuma conta. Por favor, crie uma nova conta para continuar.",
    "NEW_ACCOUNT": "Nova conta",
    "SELECTOR_SUBTITLE": "Criar uma nova conta",
    "API": {
      "SUCCESS_MESSAGE": "Conta criada com sucesso",
      "EXIST_MESSAGE": "Esta conta já existe",
      "ERROR_MESSAGE": "Não foi possível conectar ao servidor Woot, por favor tente novamente mais tarde"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Nome da empresa",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "submeter",
      "CANCEL": "Cancelar"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Ver todos os atalhos",
    "TITLE": {
      "OPEN_CONVERSATION": "Abrir conversa",
      "RESOLVE_AND_NEXT": "Resolver e passar para a próxima",
      "NAVIGATE_DROPDOWN": "Navegar pelos itens a seguir",
      "RESOLVE_CONVERSATION": "Resolver conversa",
      "GO_TO_CONVERSATION_DASHBOARD": "Ir para o painel de conversação",
      "ADD_ATTACHMENT": "Adicionar anexo",
      "GO_TO_CONTACTS_DASHBOARD": "Ir para o painel de contatos",
      "TOGGLE_SIDEBAR": "Ativar/Desativar barra lateral",
      "GO_TO_REPORTS_SIDEBAR": "Ir para barra lateral de Relatórios",
      "MOVE_TO_NEXT_TAB": "Mover para próximo separador da lista de conversas",
      "GO_TO_SETTINGS": "Ir para as configurações",
      "SWITCH_TO_PRIVATE_NOTE": "Alterar para nota privada",
      "SWITCH_TO_REPLY": "Mudar para resposta",
      "TOGGLE_SNOOZE_DROPDOWN": "Ativar/desativar suspensos",
      "AI_ASSIST_MENU": "Assistência de IA",
      "AI_ASSIST_GRAMMAR": "Corrigir gramática",
      "AI_ASSIST_UNIFY_LANG": "Unificar idioma da mensagem"
    }
  }
}
